// sacandole espacios a las secciónes de collection //


 if(document.URL.indexOf("collections")>= 0){

let banner = document.querySelector(".is-width-wide").querySelector(".container");

banner.style.padding = "20px 0px 0px 0px ";


let breadCrumbShopy = document.querySelector(".breadcrumb-collection");

breadCrumbShopy.style.margin = "0px"


let estractoSeo = document.querySelector(".boost-pfs-filter-right-col").querySelector(".container");;

estractoSeo.style.padding = "0px"

}








// footer para check out //

// if(document.URL.indexOf("checkouts")>= 0){
  
// let footerCheckOut = document.createElement("div");
// footerCheckOut.innerHTML = '<p class="mensaje_checkout">Mashini 2022</p>';

// let seccionCheckOut = document.querySelector(".content");


// seccionCheckOut.appendChild(footerCheckOut);  
  
// } 





// header para check out //


// if(document.URL.indexOf("checkouts")>= 0){

// const newNode = document.createElement("div");
// newNode.classList.add('header_checkout');

// newNode.innerHTML = '<p class="mensaje_checkout">*Promoción 2X1 Toallas de Playa: Recuerda agregar 2 productos en tu carrito para que se aplique el descuento</p>';

// const list = document.querySelector(".content");
// list.insertBefore(newNode, list.children[0]);

// }




